import {transform} from "ol/proj";
import {getWeatherData} from "@/http/services/http-services-weather";
import {hasReplaceStringAttributes, replaceMeteoValue} from "@/helpers/info-overview-helper";

export function loadMeteo(coordinate) {

    if(!hasReplaceStringAttributes('meteo')) {
        return
    }

    const coordinateLatLon = transform(coordinate, 'EPSG:3857', 'EPSG:4326')

    getWeatherData(coordinateLatLon[0], coordinateLatLon[1]).then(result => {
        replaceMeteoValue(result.liveweer[0])
    })
}
